import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import OverlayTrigger from '../overlay/OverlayTrigger';
import Tooltip from '../tooltip/Tooltip';
const ACTIVE_CLASS_NAME = 'active';
const SELECTED_CLASS_NAME = 'selected';
const LABEL_TOOLTIP_DELAY = 1500;
const TreeSidebarCategories = ({ children, currentCategoryId, onSelectCategory }) => {
    return children.map(child => {
        const id = child.props.id;
        const icon = child.props.icon || '';
        const label = child.props.label;
        const statusClassName = classNames(currentCategoryId === id ? ACTIVE_CLASS_NAME : '', child.props.hasSelection && SELECTED_CLASS_NAME);
        const handleSelectCategory = event => {
            event.stopPropagation();
            onSelectCategory(id);
        };
        const category = (_jsx("li", Object.assign({ onClick: handleSelectCategory, className: statusClassName }, { children: _jsx("div", Object.assign({ className: 'selection-bubble' }, { children: _jsx("span", { className: `rioglyph ${icon}` }) })) }), id));
        if (label) {
            const tooltip = _jsx("span", { children: label });
            return (_jsx(OverlayTrigger, Object.assign({ placement: Tooltip.RIGHT, delayShow: LABEL_TOOLTIP_DELAY, overlay: _jsx(Tooltip, Object.assign({ id: 'tooltip', width: 'auto' }, { children: tooltip })) }, { children: category }), `category-tooltip-${id}`));
        }
        return category;
    });
};
const TreeSidebar = React.memo(props => {
    const { className, onClick } = props, remainingProps = __rest(props, ["className", "onClick"]);
    const classes = classNames('TreeSidebar', className);
    return (_jsxs("div", Object.assign({ className: classes }, { children: [_jsx("ul", Object.assign({ className: 'TreeSidebarNavigation', onClick: onClick }, { children: _jsx(TreeSidebarCategories, Object.assign({}, remainingProps)) })), _jsx("div", Object.assign({ className: 'TreeSidebarToggle', onClick: onClick }, { children: _jsx("span", { className: 'rioglyph rioglyph-chevron-left' }) }))] })));
});
TreeSidebar.displayName = 'TreeSidebar';
TreeSidebar.defaultProps = {
    onClick: () => { },
};
TreeSidebar.propTypes = {
    currentCategoryId: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.node),
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};
export default TreeSidebar;
